/*
 * @Author: Latte
 * @Date: 2021-12-27 10:46:00
 * @LAstEditors: Latte
 * @LastEditTime: 2021-12-27 11:13:00
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\system\statisticsManagement\maili.js
 */

import request from "@/utils/request";
import config from "@/utils/config";

/**
 * @description: 后台获取所有的麦粒值信息并排名
 * @param {*} params
 * @return {*}
 */
export function getMAiLiInfoAndRank(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminMaiLiCredits/UserCreditList",
		method: "get",
		params,
	});
}

/**
 * @description: 后台获取指定用户的麦粒值变更详细
 * @param {*} params
 * @return {*}
 */
export function getMaiLiChangeDetail(params) {
	return request({
		url:
			config.API_MEDICAL +
			"/Api​/V1​/AdminMaiLiCredits​/User​/UserCreditOrderList",
		method: "get",
		params,
	});
}

/**
 * @description: 后台获取不同积分段的人数统计
 * @param {*} params
 * @return {*}
 */
export function getCountByMaiLiCredit(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminMaiLiCredits/CountByMaiLiCredit",
		method: "get",
		params,
	});
}

/**
 * @description: 后台获取麦粒产生和消耗统计
 * @param {*} params
 * @return {*}
 */
export function getMaiLiCountChange(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminMaiLiCredits/MaiLiCountChange",
		method: "get",
		params,
	});
}

/**
 * @description: 后台获取各个模块麦粒产生和消耗统计
 * @param {*} params
 * @return {*}
 */
export function getMaiLiCountChangeByModel(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminMaiLiCredits/MaiLiCountByModel",
		method: "get",
		params,
	});
}
